import React from "react";
import { a } from "kremling";

import { ItemBase } from "./item-base";
import { SelectDataItem } from "../common/utils";

export type ItemClearProps = {
  isSelected?: boolean;
  item: SelectDataItem;
  onChange?: (item: SelectDataItem, isMulti?: boolean) => void;
};

export const ItemClear = (props: ItemClearProps) => {
  const { isSelected, item, onChange } = props;

  const onClick = () => {
    onChange?.(item);
  };

  return (
    <ItemBase
      id={item.id}
      isSelected={isSelected}
      className={a("item-clear").m("item-clear--selected", isSelected)}
      onClick={onClick}
    >
      <div className="item-clear-content">{item.name}</div>
    </ItemBase>
  );
};
